import { FileListItem } from './file';

export interface ProductCatalog {
    id: number;
    code: string;
    name: string;
    description: string;
    active: true;
    sort: number;
    productCount: number;
    availableProductCount: number;
    createdAt: string;
    updatedAt: string;
    updatedLogin: string;
}

export interface ProductTypeItemType {
    id: number;
    code: ProductTypeCode;
    name: string;
}

export enum ProductTypeCode {
    OnlineMeeting = 'online_meeting',
    OfflineMeeting = 'offline_meeting',
    Demo = 'demo',
    License = 'license_key',
    File = 'file',
    Course = 'course',
}

export interface ProductListItem {
    id: number;
    code: string;
    type: ProductTypeItemType;
    name: string;
    description: string;
    imagePath: string;
    previewImages: FileListItem[];
    files: FileListItem[];
    productInfoUrl: string;
    active: boolean;
    price: string;
    isPriceUndefined: boolean;
    place: string;
    startAt?: string;
    endAt?: string;
    isNeedToApprove: boolean;
    isEmailDomainRestricted: boolean;
    textOrderSuccess: string;
    textOrderFail: string;
    sort: number;
    createdAt: string;
    updatedAt: string;
    updatedLogin: string;
    catalogs: ProductCatalog[];
}

export interface ProductFullInfo {
    id: number;
    code: string;
    type: ProductTypeItemType;
    name: string;
    description: string;
    imagePath: string;
    previewImages: FileListItem[];
    files: FileListItem[];
    productInfoUrl: string;
    isPriceUndefined: boolean;
    active: boolean;
    price: number;
    place: string;
    startAt: string;
    endAt: string;
    isNeedToApprove: boolean;
    textOrderSuccess: string;
    textOrderFail: string;
    isEmailDomainRestricted: boolean;

    /* CRM */
    crmInterest: CRMInterestsProduct | null;
    crmProduct: CRMProduct | null;
    crmNeedOpportunity: boolean;

    sort: number;
    createdAt: string;
    updatedAt: string;
    updatedLogin: string;
    catalogs: ProductCatalog[];
}

export interface CRMInterestsProduct {
    id: number;
    code: string;
    name: string;
    description: string;
    updatedAt: string;
    updatedLogin: string;
}

export interface CRMProduct {
    id: number;
    externalId: string;
    name: string;
    updatedAt: string;
    updatedLogin: string;
}
